export default function CircleOK() {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect
        x="0.998047"
        y="0.652344"
        width="24"
        height="24"
        rx="12"
        fill="#45B36B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7052 7.94524C20.0957 8.33576 20.0957 8.96893 19.7052 9.35945L11.7052 17.3595C11.3146 17.75 10.6815 17.75 10.2909 17.3595L6.29094 13.3595C5.90042 12.9689 5.90042 12.3358 6.29094 11.9452C6.68146 11.5547 7.31463 11.5547 7.70515 11.9452L10.998 15.2381L18.2909 7.94524C18.6815 7.55471 19.3146 7.55471 19.7052 7.94524Z"
        fill="white"
      />
    </svg>
  )
}
